var externalFileBusTerminals = [
  "Montreal, Dorval Intl (YUL)",
  "La Dorada, Terminal La Dorada (LD1)",
  "Sao Paulo, San Pablo (SAO)",
  "Rio De Janeiro, Rio de Janeiro (RIO)",
  "Sao Paulo, Tietê (SP4)",
  "Rio De Janeiro, Rodov do Rio (RJ1)",
  "Boracéia, Boracéia (101)",
  "Bofete, Bofete (10R)",
  "Boituva, Boituva (10T)",
  "Itapetininga, Itapetininga (114)",
  "Itapeva, Itapeva (115)",
  "Itapevi, Itapevi (116)",
  "Itapira, Itapira (119)",
  "Itápolis, Itápolis (11E)",
  "Itararé, Itararé (11H)",
  "Itapuí, Itapuí (11I)",
  "Itariri, Itariri (11K)",
  "Itapura, Itapura (11O)",
  "Itaquaquecetuba, Itaquaquecetuba (11P)",
  "Itaporanga, Itaporanga (11T)",
  "Itatinga, Itatinga (11V)",
  "Itatiba, Itatiba (11X)",
  "Itaporanga, Itaporanga (11Y)",
  "Abre Campo, Abre Campo (120)",
  "Abadia dos Dourados, Abadia Dos Dourados (123)",
  "Abadiânia, Abadiânia (124)",
  "Abaeté, Abaeté (125)",
  "Abaetetuba, Abaetetuba (126)",
  "Abaíra, Abaira (127)",
  "Abatiá, Abatiá (128)",
  "Abelardo Luz, Abelardo Luz (129)",
  "Adrianópolis, Adrianopolis (12A)",
  "Águas de Lindóia, Águas de Lindóia (12B)",
  "Águas da Prata, Águas da Prata (12C)",
  "Afonso Cláudio, Afonso Cláudio (12D)",
  "Acará, Acará (12E)",
  "Afrânio, Afrânio (12F)",
  "Agrestina, Agrestina (12G)",
  "Água Clara, Água Clara (12H)",
  "Acreúna, Acreúna (12I)",
  "Água Doce, Água Doce (12K)",
  "Águas de São Pedro, Águas de São Pedro (12M)",
  "Águas de Santa Bárbara, Águas de Santa Bárbara (12N)",
  "Açucena, Açucena (12O)",
  "Adamantina, Adamantina (12P)",
  "Açailândia, Açailândia (12Q)",
  "Acarape, Acarape (12R)",
  "Afogados da Ingazeira, Afogados da Ingazeira (12S)",
  "Acaraú, Acaraú (12T)",
  "Acrelândia, Acrelândia (12U)",
  "Acajutiba, Acajutiba (12W)",
  "Acopiara, Acopiara (12Y)",
  "Altinópolis, Altinópolis (13L)",
  "Alumínio, Alumínio (142)",
  "Álvares Machado, Álvares Machado (143)",
  "Alvinlândia, Alvinlândia (145)",
  "Americana, Americana (14E)",
  "Andradina, Andradina (14L)",
  "Analândia, Analândia (14O)",
  "Américo Brasiliense, Americo Brasiliense (14R)",
  "Angatuba, Angatuba (14X)",
  "Arandu, Arandu (151)",
  "Arapeí, Arapeí (155)",
  "Aracatuba, Aracatuba (15F)",
  "Araçoiaba da Serra, Araçoiaba da Serra (15H)",
  "Aramina, Aramina (15M)",
  "Araçariguama, Araçariguama (15P)",
  "Apiaí, Apiaí (15Q)",
  "Araras, Araras (160)",
  "Artur Nogueira, Artur Nogueira (166)",
  "Araraquara, Araraquara (169)",
  "Areias, Areias (16J)",
  "Ariranha, Ariranha (16Z)",
  "Arujá, Arujá (172)",
  "Assis, Assis (179)",
  "Avanhandava, Avanhandava (17A)",
  "Bálsamo, Bálsamo (17M)",
  "Avaí, Avaí (17P)",
  "Avaré, Avaré (17S)",
  "Atibaia, Atibaia (17W)",
  "Auriflama, Auriflama (17Y)",
  "Barueri, Barueri (181)",
  "Bananal, Bananal (182)",
  "Barão de Antonina, Barão de Antonina (185)",
  "Bastos, Bastos (188)",
  "Bariri, Bariri (18W)",
  "Barrinha, Barrinha (18X)",
  "Barretos, Barretos (18Z)",
  "Bebedouro, Bebedouro (190)",
  "Boa Esperança do Sul, Boa Esperança do Sul (191)",
  "Batatais, Batatais - Agência Ana Luiza (193)",
  "Batatais, Batatais - Rodoviária (194)",
  "Batatais, Batatais - TODOS (195)",
  "Bauru, Bauru (198)",
  "Bento de Abreu, Bento de Abreu (19F)",
  "Bertioga, Bertioga (19K)",
  "Belo Horizonte, Belo Horizonte - Centro (19U)",
  "Belo Horizonte, Belo Horizonte - TODOS (19O)",
  "Birigüi, Birigüi (19V)",
  "Coronel Macedo, Coronel Macedo (1A7)",
  "Cosmorama, Cosmorama (1AD)",
  "Cotia, Cotia (1AH)",
  "Cristais Paulista, Cristais Paulista (1AM)",
  "Cosmópolis, Cosmópolis (1AS)",
  "Inúbia Paulista, Inúbia Paulista (1B9)",
  "Ipuã, Ipuã (1BC)",
  "Iperó, Iperó (1BO)",
  "Ipeúna, Ipeúna (1BP)",
  "Ipaussu, Ipaussu (1BU)",
  "Iporanga, Iporanga (1BZ)",
  "Iepê, Iepê (1C1)",
  "Ibirarema, Ibirarema (1CA)",
  "Icém, Icém (1CB)",
  "Igaraçu do Tietê, Igaraçu do Tietê (1CC)",
  "Ibirá, Ibirá (1CE)",
  "Ibitinga, Ibitinga (1CG)",
  "Ibiúna, Ibiúna (1CK)",
  "Dolcinópolis, Dolcinópolis (1D1)",
  "Divinolândia, Divinolândia (1DK)",
  "Diadema, Diadema (1DT)",
  "Dois Córregos, Dois Córregos (1DV)",
  "Descalvado, Descalvado (1DW)",
  "Caconde, Caconde (1E3)",
  "Cajuru, Cajuru (1EI)",
  "Caiuá, Caiuá (1ER)",
  "Eldorado, Eldorado (1FC)",
  "Dracena, Dracena (1FD)",
  "Duartina, Duartina (1FG)",
  "Echaporã, Echaporã (1FJ)",
  "Elias Fausto, Elias Fausto (1FN)",
  "Dourado, Dourado (1FO)",
  "Eldorado, Eldorado (1FV)",
  "Engenheiro Coelho, Engenheiro Coelho (1G4)",
  "Espírito Santo do Pinhal, Espírito Santo do Pinhal (1GJ)",
  "Espírito Santo do Turvo, Espírito Santo do Turvo (1GK)",
  "Estrela do Norte, Estrela do Norte (1H2)",
  "Estrela do Norte, Estrela do Norte (1H3)",
  "Ferraz de Vasconcelos, Ferraz de Vasconcelos (1HC)",
  "Fartura, Fartura (1HR)",
  "Fernandópolis, Fernandópolis (1HX)",
  "Cesário Lange, Cesário Lange (1IP)",
  "Cerqueira César, Cerqueira César (1IT)",
  "Chavantes, Chavantes (1IV)",
  "Charqueada, Charqueada (1IX)",
  "Cerquilho, Cerquilho (1IY)",
  "Floreal, Floreal (1J5)",
  "Flórida Paulista, Flórida Paulista (1JE)",
  "Fortaleza, Fortaleza - João Thomé (1JH)",
  "Fortaleza, Fortaleza - TODOS (1JK)",
  "Franca, Franca (1JV)",
  "Florianopolis, Florianópolis (1JW)",
  "Glicério, Glicério (1K1)",
  "General Salgado, General Salgado (1KH)",
  "Gavião Peixoto, Gavião Peixoto (1KS)",
  "Getulina, Getulina (1KX)",
  "Garça, Garça (1KY)",
  "Goiania, Goiânia (1L7)",
  "Guaimbê, Guaimbê (1LC)",
  "Guaiçara, Guaiçara (1LX)",
  "Itaí, Itaí (1M5)",
  "Itanhaém, Itanhaém (1MF)",
  "Iracemápolis, Iracemápolis (1N2)",
  "Irapuru, Irapuru (1N8)",
  "Itaberá, Itaberá (1NS)",
  "Colina, Colina (1OI)",
  "Conchal, Conchal (1P5)",
  "Conchas, Conchas (1P6)",
  "Cordeirópolis, Cordeirópolis (1PL)",
  "Coroados, Coroados (1PP)",
  "Botucatu, Botucatu (1Q5)",
  "Bragança Paulista, Bragança Paulista (1Q8)",
  "Brotas, Brotas (1QC)",
  "Brasilia, Brasília - Rodoviaria Interestadual (1QI)",
  "Brasilia, Brasília - Todos (1QO)",
  "Brodowski, Brodowski (1QZ)",
  "Campinas, Campinas - Aeroporto de Viracopos (1RQ)",
  "Campinas, Campinas (1R0)",
  "Campina do Monte Alegre, Campina do Monte Alegre (1R5)",
  "Campinas, Campinas - TODOS (1RW)",
  "Campos do Jordão, Campos do Jordão (1RZ)",
  "Cruzeiro, Cruzeiro (1SA)",
  "Cubatão, Cubatão - Casqueiro (1SG)",
  "Cubatão, Cubatão (1SH)",
  "Curitiba, Curitiba (1SX)",
  "Curitiba, Curitiba - Aeroporto (1SC)",
  "Cananéia, Cananéia (1T2)",
  "Canas, Canas (1T3)",
  "Cândido Mota, Cândido Mota (1T6)",
  "Capela do Alto, Capela do Alto (1TC)",
  "Capão Bonito, Capão Bonito (1TL)",
  "Canitar, Canitar (1TS)",
  "Casa Branca, Casa Branca (1UE)",
  "Castilho, Castilho (1UF)",
  "Catanduva, Catanduva (1UL)",
  "Igarapava, Igarapava (1V2)",
  "Iguape, Iguape (1V7)",
  "Iguape, Iguape - Itimirim (1V8)",
  "Indiaporã, Indiaporã (1VN)",
  "Ilha Solteira, Ilha Solteira (1VR)",
  "Ilhabela, Ilhabela (1VT)",
  "Ilha Comprida, Ilha Comprida (1VW)",
  "Indaiatuba, Indaiatuba (1VX)",
  "Buri, Buri (1W5)",
  "Buritizal, Buritizal (1W8)",
  "Cachoeira Paulista, Cachoeira Paulista (1WL)",
  "Caçapava, Caçapava (1WO)",
  "Ibaté, Ibaté (1XC)",
  "Iacanga, Iacanga (1XF)",
  "Hortolândia, Hortolândia (1XO)",
  "Herculândia, Herculândia (1XT)",
  "Guzolândia, Guzolândia (1XW)",
  "Capivari, Capivari (1Y8)",
  "Cardoso, Cardoso (1YF)",
  "Caraguatatuba, Caraguatatuba (1YQ)",
  "Guapiara, Guapiara (1Z2)",
  "Guará, Guará (1Z4)",
  "Guaraçaí, Guaraçaí (1Z6)",
  "Guaraci, Guaraci (1Z7)",
  "Guaraci, Guaraci (1Z8)",
  "Guararapes, Guararapes (1ZH)",
  "Guararema, Guararema (1ZJ)",
  "Guarulhos, Guarulhos (1ZM)",
  "Guarulhos, Guarulhos - Aeroporto de Cumbica (1Z1)",
  "Guarulhos, Guarulhos - TODOS (1ZZ)",
  "Guarujá, Guarujá (1ZN)",
  "Guarantã, Guarantã (1ZP)",
  "Guarantã, Guaranta - Posto Pontilhão 300 (1ZA)",
  "Guareí, Guareí (1ZV)",
  "Guaratinguetá, Guaratinguetá (1ZX)",
  "Marilia, Marilia (206)",
  "Martinópolis, Martinópolis (20A)",
  "Matão, Matão (20L)",
  "Itirapina, Itirapina (219)",
  "Itu, Itu (21E)",
  "Ituverava, Ituverava (21F)",
  "Jacareí, Jacareí (21M)",
  "Itupeva, Itupeva (21O)",
  "Itobi, Itobi (21Q)",
  "Jaboticabal, Jaboticabal (21V)",
  "São João da Boa Vista, São João da Boa Vista (226)",
  "São Joaquim da Barra, São Joaquim da Barra (22F)",
  "São José da Bela Vista, São José da Bela Vista (22L)",
  "Jacupiranga, Jacupiranga (235)",
  "Jandira, Jandira (23D)",
  "Jales, Jales (23I)",
  "Jambeiro, Jambeiro (23O)",
  "Jaú, Jaú (240)",
  "José Bonifácio, José Bonifácio (242)",
  "João Ramalho, João Ramalho (24C)",
  "Juquiá, Juquiá (25D)",
  "Juquitiba, Juquitiba (25F)",
  "Jundiaí, Jundiaí (25I)",
  "Junqueirópolis, Junqueirópolis (25P)",
  "Juiz De Fora, Juíz de Fora - São Dimas (25R)",
  "Juiz De Fora, Juíz de Fora - TODOS (25Y)",
  "Leme, Leme (262)",
  "Lençóis Paulista, Lençóis Paulista (266)",
  "Lavrinhas, Lavrinhas (26B)",
  "Lavínia, Lavínia (26Z)",
  "Limeira, Limeira (278)",
  "Louveira, Louveira (27D)",
  "Lucélia, Lucélia (27G)",
  "Lorena, Lorena (27S)",
  "Lins, Lins (27T)",
  "Lutécia, Lutécia (27V)",
  "Lindóia, Lindóia (27W)",
  "Lupércio, Lupércio (27X)",
  "Mairiporã, Mairiporã (28A)",
  "Manduri, Manduri (28N)",
  "Mairinque, Mairinque (28P)",
  "Mágda, Mágda (28Y)",
  "Maracaí, Maracaí (29T)",
  "Marabá Paulista, Marabá Paulista (29W)",
  "Pariquera-Açu, Pariquera-Açu (2A6)",
  "Paulo de Faria, Paulo de Faria (2AB)",
  "Patrocínio Paulista, Patrocínio Paulista (2AD)",
  "Paulicéia, Paulicéia (2AL)",
  "Paulínia, Paulínia (2AZ)",
  "Santa Mercedes, Santa Mercedes (2B1)",
  "Santa Rosa de Viterbo, Santa Rosa de Viterbo (2BE)",
  "Santana da Ponte Pensa, Santana da Ponte Pensa (2BG)",
  "Santa Salete, Santa Salete (2BU)",
  "Roseira, Roseira (2C5)",
  "Saltinho, Saltinho (2CD)",
  "Salto de Pirapora, Salto de Pirapora (2CG)",
  "Salto Grande, Salto Grande (2CL)",
  "Santa Albertina, Santa Albertina (2CM)",
  "Santa Adélia, Santa Adélia (2CN)",
  "Saltinho, Saltinho (2CS)",
  "Salesópolis, Salesópolis (2CU)",
  "Sales Oliveira, Sales Oliveira (2CY)",
  "Salto, Salto (2CZ)",
  "Piquerobi, Piquerobi (2D2)",
  "Peruíbe, Peruíbe (2D6)",
  "Piquete, Piquete (2DD)",
  "Pindamonhangaba, Pindamonhangaba (2DF)",
  "Pindorama, Pindorama (2DH)",
  "Pinhalzinho, Pinhalzinho (2DL)",
  "Pilar do Sul, Pilar do Sul (2DO)",
  "Piedade, Piedade (2DU)",
  "Pinhalzinho, Pinhalzinho (2DZ)",
  "Monte Castelo, Monte Castelo (2E0)",
  "Monte Alto, Monte Alto (2E3)",
  "Monte Aprazível, Monte Aprazível (2E4)",
  "Monte Azul Paulista, Monte Azul Paulista (2E5)",
  "Morro Agudo, Morro Agudo (2EC)",
  "Monte Castelo, Monte Castelo (2EQ)",
  "Monte Mor, Monte Mor (2ER)",
  "Monteiro Lobato, Monteiro Lobato (2EU)",
  "Pirajuí, Pirajuí (2F0)",
  "Piracicaba, Piracicaba (2F4)",
  "Piraju, Piraju (2F9)",
  "Pitangueiras, Pitangueiras (2FC)",
  "Pirassununga, Pirassununga (2FI)",
  "Piratininga, Piratininga (2FO)",
  "Pirapozinho, Pirapozinho (2FU)",
  "Pirangi, Pirangi (2FW)",
  "Pitangueiras, Pitangueiras (2FX)",
  "Poá, Poá (2G8)",
  "Pontalinda, Pontalinda (2GK)",
  "Pompéia, Pompéia (2GP)",
  "Poloni, Poloni (2GY)",
  "Porangaba, Porangaba (2H1)",
  "Porto Feliz, Porto Feliz (2HA)",
  "Porto Ferreira, Porto Ferreira (2HS)",
  "Olímpia, Olímpia (2I1)",
  "Oriente, Oriente (2I7)",
  "Orindiúva, Orindiúva (2I8)",
  "Osvaldo Cruz, Osvaldo Cruz (2IA)",
  "Ouro Verde, Ouro Verde (2IB)",
  "Ourinhos, Ourinhos (2IJ)",
  "Pacaembu, Pacaembu (2IM)",
  "Ouroeste, Ouroeste (2IN)",
  "Oscar Bressane, Oscar Bressane (2IO)",
  "Osasco, Osasco (2IU)",
  "Orlândia, Orlândia (2IW)",
  "Promissão, Promissão (2J2)",
  "Presidente Bernardes, Presidente Bernardes (2JA)",
  "Presidente Epitácio, Presidente Epitácio (2JG)",
  "Presidente Alves, Presidente Alves (2JP)",
  "Presidente Venceslau, Presidente Venceslau (2JV)",
  "Presidente Prudente, Presidente Prudente (2JX)",
  "Quadra, Quadra (2K4)",
  "Quatá, Quatá (2K7)",
  "Queluz, Queluz (2KE)",
  "Quintana, Quintana (2KO)",
  "Rancharia, Rancharia (2KX)",
  "Registro, Registro - Serrote (2LQ)",
  "Registro, Registro (2L0)",
  "Regente Feijó, Regente Feijó (2L8)",
  "Reginópolis, Reginópolis (2L9)",
  "Ribeira, Ribeira (2LL)",
  "São Bento do Sapucaí, São Bento do Sapucaí (2M1)",
  "São Bernardo do Campo, São Bernardo do Campo (2M6)",
  "São Caetano do Sul, São Caetano do Sul (2M9)",
  "Santo Anastácio, Santo Anastácio (2N6)",
  "Santo Antônio da Alegria, Santo Antônio da Alegria (2N8)",
  "Santos, Santos - José Menino (2NZ)",
  "Santos, Santos - Ponta da Praia (2NX)",
  "Santos, Santos - Porto de Santos (2NC)",
  "Santos, Santos - Rodoviária (2NV)",
  "Santos, Santos - TODOS (2NB)",
  "Santo Antônio do Jardim, Santo Antônio do Jardim (2NI)",
  "Santo Antônio do Pinhal, Santo Antônio do Pinhal (2NS)",
  "Palmital, Palmital (2OC)",
  "Palestina, Palestina (2OE)",
  "Palmares Paulista, Palmares Paulista (2OP)",
  "Palestina, Palestina (2OR)",
  "Palmital, Palmital (2OX)",
  "Panorama, Panorama (2P3)",
  "Paranapuã, Paranapuã (2PB)",
  "Paranapanema, Paranapanema (2PC)",
  "Parapuã, Parapuã (2PP)",
  "Paraguaçu Paulista, Paraguaçu Paulista (2PQ)",
  "Paraibuna, Paraibuna (2PT)",
  "Miracatu, Miracatu (2Q2)",
  "Mauá, Mauá (2Q7)",
  "Miguelópolis, Miguelópolis (2QF)",
  "Mira Estrela, Mira Estrela (2QN)",
  "Mineiros do Tietê, Mineiros do Tietê (2QV)",
  "Murutinga do Sul, Murutinga do Sul (2RD)",
  "Nantes, Nantes (2RK)",
  "Pederneiras, Pederneiras (2S1)",
  "Pereira Barreto, Pereira Barreto (2S2)",
  "Pedra Bela, Pedra Bela (2S4)",
  "Pedregulho, Pedregulho (2SE)",
  "Pedro de Toledo, Pedro de Toledo (2SI)",
  "Penápolis, Penápolis (2SJ)",
  "Pereiras, Pereiras (2SS)",
  "Nazaré Paulista, Nazaré Paulista (2T1)",
  "Nhandeara, Nhandeara (2T8)",
  "Novo Horizonte, Novo Horizonte (2UA)",
  "Nuporanga, Nuporanga (2UC)",
  "Ocauçu, Ocauçu (2UN)",
  "Novo Horizonte, Novo Horizonte (2UO)",
  "Novo Horizonte, Novo Horizonte (2UP)",
  "Santa Cruz das Palmeiras, Santa Cruz das Palmeiras (2V0)",
  "Santa Branca, Santa Branca (2V5)",
  "Santa Cruz da Esperança, Santa Cruz da Esperança (2V9)",
  "Santa Isabel, Santa Isabel (2VD)",
  "Santa Cruz do Rio Pardo, Santa Cruz do Rio Pardo (2VE)",
  "Santa Fé do Sul, Santa Fé do Sul (2VI)",
  "Santa Maria da Serra, Santa Maria da Serra (2VZ)",
  "Mirandópolis, Mirandópolis (2W8)",
  "Mogi Guaçu, Mogi Guaçu (2WD)",
  "Mogi Mirim, Mogi Mirim (2WF)",
  "Mombuca, Mombuca (2WJ)",
  "Mongaguá, Mongaguá (2WL)",
  "Mirassol, Mirassol (2WQ)",
  "Mogi das Cruzes, Mogi das Cruzes (2WS)",
  "Mococa, Mococa (2WU)",
  "Rosana, Rosana (2X2)",
  "Riolândia, Riolândia (2XR)",
  "Nova Europa, Nova Europa (2Y4)",
  "Nova Odessa, Nova Odessa (2YJ)",
  "Nova Granada, Nova Granada (2YQ)",
  "Nova Independência, Nova Independência (2YR)",
  "Ribeirão Bonito, Ribeirão Bonito (2Z1)",
  "Ribeirão Grande, Ribeirão Grande (2Z7)",
  "Ribeirão Pires, Ribeirão Pires (2Z8)",
  "Ribeirao Preto, Ribeirão Preto (2Z9)",
  "Rio De Janeiro, Rio de Janeiro - Campo Grande (2ZK)",
  "Rio De Janeiro, Rio de Janeiro - TODOS (2ZC)",
  "Rio De Janeiro, Rio de Janeiro - Barra da Tijuca (2ZJ)",
  "Rio De Janeiro, Rio de Janeiro - Castelo (2ZL)",
  "Rio De Janeiro, Rio de Janeiro - Rodov. do Rio (2ZX)",
  "Rio De Janeiro, Rio de Janeiro - Aeroporto Galeao (2ZH)",
  "Rifaina, Rifaina (2ZE)",
  "Rio das Pedras, Rio das Pedras (2ZF)",
  "Rinópolis, Rinópolis (2ZR)",
  "Tramandaí, Tramandaí - TODOS (305)",
  "Tremembé, Tremembé (308)",
  "Três Fronteiras, Três Fronteiras (30R)",
  "São Manuel, São Manuel (313)",
  "São José do Barreiro, São José do Barreiro (314)",
  "Sao Jose Dos Campos, São José dos Campos (31S)",
  "São José do Rio Pardo, São José do Rio Pardo (31T)",
  "São Luís, São Luis (31V)",
  "Sao Jose Do Rio Preto, São José do Rio Preto (31Y)",
  "Sao Jose Do Rio Preto, São José do Rio Preto - Rodoviária (31U)",
  "Sao Jose Do Rio Preto, São José do Rio Preto - Vip Itamarati (31I)",
  "São Miguel Arcanjo, São Miguel Arcanjo (328)",
  "São Pedro, São Pedro (32C)",
  "Sao Paulo, São Paulo - Jabaquara (32P)",
  "Sao Paulo, São Paulo - Tietê (32S)",
  "Sao Paulo, São Paulo - Sao Mateus (32A)",
  "Sao Paulo, São Paulo - Barra Funda (32O)",
  "Sao Paulo, São Paulo - TODOS (32D)",
  "Sao Paulo, São Paulo - Aeroporto de Congonhas (32I)",
  "São Roque, São Roque (32M)",
  "São Simão, São Simão (340)",
  "São Sebastião da Grama, São Sebastião da Grama (341)",
  "Sarapuí, Sarapuí (34K)",
  "São Simão, São Simão (34Q)",
  "Sarutaiá, Sarutaiá (34Z)",
  "Sete Barras, Sete Barras (355)",
  "Serrana, Serrana (35J)",
  "Silveiras, Silveiras (360)",
  "Severínia, Severínia (364)",
  "Socorro, Socorro (36G)",
  "Sorocaba, Sorocaba (36V)",
  "Taboão da Serra, Taboão da Serra (370)",
  "Sumare, Sumare (371)",
  "Suzano, Suzano (375)",
  "Tabatinga, Tabatinga (378)",
  "Tambaú, Tambaú (37G)",
  "Tanabi, Tanabi (37L)",
  "Taguaí, Taguaí (37U)",
  "Taquarituba, Taquarituba (380)",
  "Tapiraí, Tapiraí (381)",
  "Tapiratiba, Tapiratiba (384)",
  "Taquaritinga, Taquaritinga (389)",
  "Teodoro Sampaio, Teodoro Sampaio (38G)",
  "Taubaté, Taubaté (38I)",
  "Teodoro Sampaio, Teodoro Sampaio (38J)",
  "Tatuí, Tatuí (38R)",
  "Teresina, Teresina (38V)",
  "Tarumã, Tarumã (38W)",
  "Tietê, Tietê (398)",
  "Trabiju, Trabiju (39C)",
  "Torre de Pedra, Torre de Pedra (39L)",
  "Torrinha, Torrinha (39X)",
  "Vinhedo, Vinhedo (3E3)",
  "Várzea Paulista, Várzea Paulista (3E5)",
  "Viradouro, Viradouro (3EE)",
  "Vera Cruz, Vera Cruz (3EY)",
  "Tupi Paulista, Tupi Paulista (3Q9)",
  "Turmalina, Turmalina (3QE)",
  "Ubatuba, Ubatuba (3QJ)",
  "Ubatuba, Ubatuba - Maranduba (3QK)",
  "Turmalina, Turmalina (3QW)",
  "Vista Alegre do Alto, Vista Alegre do Alto (3R8)",
  "Vitoria, Vitória (3RE)",
  "Votorantim, Votorantim (3RO)",
  "Votuporanga, Votuporanga (3RP)",
  "Urânia, Urânia (3W7)",
  "Valinhos, Valinhos (3WJ)",
  "Valparaíso, Valparaíso (3WK)",
  "Vargem Grande do Sul, Vargem Grande do Sul (3WN)",
  "Urupês, Urupês (3WO)",
  "Montes Claros, Terminal Rod. Montes Claros (20V)",
  "Buzios, Búzios - Centro (A1A)",
  "Buzios, Búzios - Manguinhos (A2A)",
  "Buzios, Búzios - Ferradura (A3A)",
  "Buzios, Búzios - João Fernandes (A4A)",
  "Rio das Flores, Rio das Flores - Abarracamento (A5A)",
  "Areal, Areal - Alberto Torres (A6A)",
  "São Gonçalo, São Gonçalo - Alcantara (A7A)",
  "Vassouras, Vassouras - Andrade Pinto (A8A)",
  "Sapucaia, Sapucaia - Anta (A9A)",
  "São João de Meriti, São João de Meriti - Arcozelo (A1B)",
  "São João de Meriti, São João de Meriti (A2B)",
  "Paty do Alferes, Paty do Alferes - Avelar (A3B)",
  "Saquarema, Saquarema - Bacaxá (A4B)",
  "Paraíba do Sul, Paraíba do Sul - Barão de Angra (A5B)",
  "Casimiro de Abreu, Casimiro de Abreu - Barra de São João (A6B)",
  "Bom Jesus do Itabapoana, Bom Jesus do Itabapoana - Barra do Itabapoana (A7B)",
  "Três Rios, Três Rios - Bemposta (A1C)",
  "Cantagalo, Cantagalo (A2C)",
  "Cantagalo, Cantagalo - Boa Sorte (A3C)",
  "Itaperuna, Itaperuna - Boa Ventura (A4C)",
  "Cachoeiras de Macacu, Cachoeiras de Macacu - Boca do Mato (A5C)",
  "Rio De Janeiro, Rio de Janeiro - Bonsucesso (A6C)",
  "São Fidélis, São Fidélis - Cambiasca (A7C)",
  "Rio De Janeiro, Rio de Janeiro - Campo Grande (A8C)",
  "Campos dos Goytacazes, Campos dos Goytacazes - Centro (A9C)",
  "Cabo Frio, Cabo Frio - Campos Novos (A1D)",
  "Rio De Janeiro, Rio de Janeiro - Castelo (A2D)",
  "Rio De Janeiro, Rio de Janeiro - Cidade Universitária (A3D)",
  "Campos dos Goytacazes, Campos dos Goytacazes - Conselheiro Josino (A4D)",
  "Algodão de Jandaíra, Petrópolis - Correas (A5D)",
  "Campos dos Goytacazes, Campos dos Goytacazes - Correnteza (A6D)",
  "Resende, Resende - Engenheiro Passos (A7D)",
  "Cantagalo, Cantagalo - Euclidelandia (A8D)",
  "Campos dos Goytacazes, Campos dos Goytacazes - Farol de São Tomé (A9D)",
  "Duque de Caxias, Duque de Caxias - Figueira (A1E)",
  "Quissamã, Quissimã - Floresta (A2E)",
  "Volgograd, Macaé - Frade (A3E)",
  "Mangaratiba, Mangaratiba - Itacuruça (A4E)",
  "Algodão de Jandaíra, Petrópolis - Itaipava (A5E)",
  "Saquarema, Saquarema - Jacone (A6E)",
  "São Gonçalo, São Gonçalo - Manilha (A7E)",
  "Maricá, Maricá - Manoel Ribeiro (A8E)",
  "Rio das Flores, Rio das Flores - Manuel Duarte (A9E)",
  "Santo Antônio de Pádua, Santo Antonio de Padua - Marangatu (A1F)",
  "Rio das Ostras, Rio das Ostras - Mar do Norte (A2F)",
  "Duas Barras, Duas Barras - Monerat (A3F)",
  "Rio De Janeiro, Rio de Janeiro - Morrinhos (A4F)",
  "Vassouras, Vassouras - Morro Azul (A5F)",
  "Campos dos Goytacazes, Campos dos Goytacazes - Morro do Coco (A6F)",
  "Rio De Janeiro, Rio de Janeiro - Niterói (Barcas) (A7F)",
  "Nova Friburgo, Nova Friburgo (RNorte) (A8F)",
  "Nova Friburgo, Nova Friburgo (RSul) (A9F)",
  "Parati, Parati (A1G)",
  "Rio Claro, Rio Claro (A2G)",
  "Rio Claro, Rio Claro - Passa Três (A3G)",
  "Rio De Janeiro, Rio de Janeiro - Peclas (A4G)",
  "Algodão de Jandaíra, Petrópolis - Pedro do Rio (A5G)",
  "São José do Vale do Rio Preto, São José do Vale do Rio Preto - Pião (A6G)",
  "Araruama, Araruama - Posse (A7G)",
  "Itaboraí, Itaboraí - Pracinha (A8G)",
  "Araruama, Araruama - Praia Seca (A9G)",
  "São Fidélis, São Fidélis - Pureza (A1H)",
  "Itaperuna, Itaperuna - Raposo (A2H)",
  "Resende, Resende - Manejo (A3H)",
  "Resende, Resende - Graal Shopping (A4H)",
  "Rio De Janeiro, Rio de Janeiro - Resplendor (A5H)",
  "Rio De Janeiro, Rio de Janeiro - Alvorada - Barra da Tijuca (A6H)",
  "Casimiro de Abreu, Casimiro de Abreu - Rio Dourado (A7H)",
  "Rio De Janeiro, Rio de Janeiro - Sampaio Correia (A8H)",
  "Bom Jesus do Itabapoana, Bom Jesus do Itabapoana - Santo Eduardo (A9H)",
  "Cambuci, Cambuci - São João do Paraíso (A1I)",
  "Campos dos Goytacazes, Campos dos Goytacazes - São Martinho (A2I)",
  "Barra do Piraí, Barra do Piraí - São Sebastião Alto (A3I)",
  "Araruama, Araruama - São Vicente de Paula (A4I)",
  "Belford Roxo, Belford Roxo - Teodoro de Oliveira (A5I)",
  "Rio das Flores, Rio das Flores - Três Ilhas (A6I)",
  "Cabo Frio, Cabo Frio - Unamar (A7I)",
  "Engenheiro Paulo de Frontin, Eng. Paulo de Frontin - Vila Operária (A8I)",
  "Trajano de Morais, Trajano de Morais - Visconde do Imbé (A9I)",
  "Paraíba do Sul, Paraíba do Sul - Werneck (A1J)",
  "João Neiva, João Neiva - Acioli (A2J)",
  "Aracruz, Aracruz - Agua Boa (A3J)",
  "Nova Venécia, Nova Venécia - Água Limpa (A4J)",
  "Anchieta, Anchieta - Centro (A5J)",
  "Domingos Martins, Domingos Martins - Aracê (A6J)",
  "Marechal Floriano, Marechal Floriano - Araguaia (A7J)",
  "Colatina, Colatina - Barbados (A8J)",
  "Vila Velha, Vila Velha - Barra do Sabiá (A9J)",
  "Colatina, Colatina - Baunilha (A1K)",
  "Linhares, Linhares - Bebedouro (A2K)",
  "Marilândia, Marilândia - Bela Vista (A3K)",
  "Boa Esperança, Boa Esperança (A4K)",
  "Alegre, Alegre - Boa Sorte (A5K)",
  "Linhares, Linhares - Boa Vista (A6K)",
  "Conceição da Barra, Conceição da Barra - Braço do Rio (A7K)",
  "Linhares, Linhares - Canivete (A8K)",
  "Serra, Serra - Carapina (A9K)",
  "Alfredo Chaves, Alfredo Chaves - Carolina (A1L)",
  "João Neiva, João Neiva - Cavalinhos (A2L)",
  "Aracruz, Aracruz - Coqueiral (A3L)",
  "Pedro Canário, Pedro Canário - Cristal do Norte (A4L)",
  "Guarapari, Guarapari - Centro (A5L)",
  "São Mateus, São Mateus - Guriri (A6L)",
  "Anchieta, Anchieta - Iriri (A7L)",
  "Ponto Belo, Ponto Belo - Itamira (A8L)",
  "Colatina, Colatina - Itapina (A9L)",
  "São Mateus, São Mateus - Itauninhas (A1M)",
  "Serra, Serra - Jacaraipe (A2M)",
  "Aracruz, Aracruz - Jacupemba (A3M)",
  "Pancas, Pancas - Lajinha (A4M)",
  "Baixo Guandu, Baixo Guandu - Mascarenhas (A5M)",
  "Alfredo Chaves, Alfredo Chaves - Matilda (A6M)",
  "Guarapari, Guarapari - Meaipe (A7M)",
  "São Mateus, São Mateus - Nestor Gomes (A8M)",
  "Serra, Serra - Nova Almeida (A9M)",
  "Domingos Martins, Domingos Martins - Paraju (A1N)",
  "Ibiraçu, Ibiraçu - Pendanga (A2N)",
  "Iúna, Iúna - Pequia (A3N)",
  "Muniz Freire, Muniz Freire - Piacu (A4N)",
  "Domingos Martins, Domingos Martins - Ponto Alto (A6N)",
  "Marechal Floriano, Marechal Floriano - Rio Fundo (A7N)",
  "Nova Venécia, Nova Venécia - Rio Preto (A8N)",
  "Conceição da Barra, Conceição da Barra - Santana (A9N)",
  "Serra, Serra - São Domingos (A1O)",
  "Colatina, Colatina - São Gabriel da Baunilha (A2O)",
  "Boa Esperança, Boa Esperança - São José do Sobradinho (A3O)",
  "São Gabriel da Palha, São Gabriel da Palha - São Roque (A4O)",
  "Conceição da Barra, Conceição da Barra - Sayonara (A5O)",
  "Vila Velha, Vila Velha - Santa Terezinha (A6O)",
  "Fundão, Fundão - Timbui (A7O)",
  "Fundão, Fundão - Três Barras (A8O)",
  "Marechal Floriano, Marechal Floriano - Victor Hugo (A9O)",
  "Aracruz, Aracruz - Vila Riacho (A2P)",
  "Montanha, Montanha - Vinhatico (A3P)",
  "Aporé, Aporé (A4P)",
  "Arenópolis, Arenópolis (A5P)",
  "Bom Jardim de Goiás, Bom Jardim de Goiás (A6P)",
  "São João d'Aliança, São João D'Aliança - Bela Vista (A7P)",
  "Nazário, Nazário - Claudinápoli (A8P)",
  "Bonópolis, Bonópolis - Cruz Norte (A9P)",
  "Anapolis, Anápolis - Hinterlândia (A1Q)",
  "Montividiu, Montividiu - Mata Azul (A2Q)",
  "Moiporá, Moiporá - Messianópolis (A3Q)",
  "Anapolis, Anápolis - Paraíso (A4Q)",
  "Israelândia, Israelândia - Piloandia (A5Q)",
  "Alvorada do Norte, Alvorada do Norte - Rancho Alegre (A6Q)",
  "Montes Claros de Goiás, Montes Claros de Goiás - Registro do Araguaia (A7Q)",
  "Rio Quente, Rio Quente (AQ8)",
  "Catalão, Catalão - Santa Helena (A9Q)",
  "São João d'Aliança, São João D'Aliança (A1R)",
  "Itumbiara, Itumbiara - Sarandi (A2R)",
  "Valparaíso de Goiás, Valparaíso de Goiás (A3R)",
  "Campinorte, Campinorte - Pau Terra (A4R)",
  "Goiatuba, Goiatuba - Brejo Bonito (A5R)",
  "Morrinhos, Morrinhos - Marcelandia (A6R)",
  "Pirenópolis, Pirenópolis - Bom Jesus (A7R)",
  "Planaltina de Goiás, Planaltina de Goiás (A8R)",
  "Planaltina de Goiás, Planaltina de Goiás - São Gabriel (A9R)",
  "São Miguel do Araguaia, São Miguel do Araguaia - Infusão (A1S)",
  "São Miguel do Araguaia, São Miguel do Araguaia - Tataira (A2S)",
  "Alto Boa Vista, Alto Boa Vista (A3S)",
  "Araguaiana, Araguaiana (A4S)",
  "Araguainha, Araguainha (A5S)",
  "Cuiaba, Cuiabá - Arica (A6S)",
  "Castanheira, Castanheira (A7S)",
  "Figueirópolis D'Oeste, Figueirópolis D'Oeste (A8S)",
  "Rio Branco, Rio Branco (A9S)",
  "Rondonopolis, Rondonópolis - Serra Dourada (A1T)",
  "Santa Rita do Trivelato, Santa Rita do Trivelato (A2T)",
  "Várzea Grande, Várzea Grande (A3T)",
  "Água Boa, Água Boa (A4T)",
  "Alto Garças, Alto Garças - Boa Vista (A5T)",
  "Barra do Garças, Barra do Garças (A6T)",
  "Barra do Garças, Barra do Garças - Vale dos Sonhos (A7T)",
  "Canarana, Canarana (A8T)",
  "Jaciara, Jaciara - Pensão Seca (A9T)",
  "Juruena, Juruena (A1U)",
  "Juscimeira, Juscimeira - Salta Elvira (A2U)",
  "Mirassol D'Oeste, Mirassol D'Oeste (A3U)",
  "Conquista D'Oeste, Conquista D'Oeste - Nova Lacerda (A4U)",
  "São Félix do Araguaia, São Félix do Araguaia - Espigão do Leste (A5U)",
  "Campo Grande, Campo Grande - Anhandui (A6U)",
  "Bandeirantes, Bandeirantes (A7U)",
  "Douradina, Douradina - Bocajá (A8U)",
  "Campo Grande, Campo Grande (A9U)",
  "Camapuã, Camapuã - Capim Grande (A1V)",
  "Dourados, Dourados - Continental (A2V)",
  "Corumba, Corumbá - Formosa (A3V)",
  "Dourados, Dourados - Indapolis (A4V)",
  "Costa Rica, Costa Rica - Paraíso das Águas (A5V)",
  "Campo Grande, Campo Grande - Porto Alice (A6V)",
  "Santa Rita do Pardo, Santa Rita do Pardo (A7V)",
  "Dourados, Dourados - Vila Vargas (A8V)",
  "Amambaí, Amambaí - Três Barras (A9V)",
  "Angélica, Angélica - Ipezal (A1X)",
  "Aparecida do Taboado, Aparecida do Taboado (A2X)",
  "Aquidauana, Aquidauna (A3X)",
  "Bela Vista, Bela Vista - Salobra (A4X)",
  "Bonito, Bonito (A5X)",
  "Camapuã, Camapuã (A6X)",
  "Caracol, Caracol (A7X)",
  "Itaporã, Itaporã - Montese (A8X)",
  "Itaporã, Itaporã - Pirapora (A9X)",
  "Ivinhema, Ivinhema - Amandina (A1W)",
  "Miranda, Miranda - Cachoeirinha (A2W)",
  "Miranda, Miranda - Guaicurus (A3W)",
  "Miranda, Miranda - Jatobá (A4W)",
  "Nioaque, Nioaque - Vila São Pedro (A5W)",
  "Nova Andradina, Nova Andradina - Nova Casa Verde (A6W)",
  "Porto Murtinho, Porto Murtinho - Porto Morrinho (A7W)",
  "Rio Brilhante, Rio Brilhante - Aroeira (A8W)",
  "Aparecida, Aparecida SP (K1A)",
  "Areiópolis, Areiópolis (K1B)",
  "Barra Bonita, Barra Bonita (K1C)",
  "Bernardino de Campos, Bernardinho de Campos (K1D)",
  "Bocaina, Bocaina (K1E)",
  "Borborema, Borborema (K1F)",
  "Cafelândia, Cafelândia (K1G)",
  "Cajati, Cajati (K1H)",
  "Estrela D'Oeste, Estrela D'Oeste (K1I)",
  "Euclides da Cunha Paulista, Euclides da Cunha Paulista (K1J)",
  "Florínia, Florínia (K1K)",
  "Pederneiras, Pederneiras Guaianas (K1L)",
  "Guaíra, Guaíra (K1M)",
  "Guarani D'Oeste, Guarani D'Oeste (K1N)",
  "Itirapuã, Itirapuã (K1O)",
  "Laranjal Paulista, Laranjal Paulista (K1P)",
  "Peruíbe, Peruíbe Barra do Una (K1Q)",
  "Sao Paulo, São Paulo Piracuama (K1R)",
  "Praia Grande, Praia Grande (K1S)",
  "Praia Grande, Praia Grande Basto (K1T)",
  "Aracatuba, Aracatuba - Primavera (K1U)",
  "Nazaré Paulista, Nazaré Cuiaba PTA (K1V)",
  "Itapira, Itapira Barão Nogueira (K1W)",
  "Itapira, Itapira Barão Ataliba Nogueira (K1X)",
  "Estrela D'Oeste, Estrela D'Oeste Bandeirantes (K1Y)",
  "Rio Claro, Rio Claro Entrada (K1Z)",
  "Rio Claro, Rio Claro (K2A)",
  "Bertioga, Bertioga - Riviera de São Lourenço (K2B)",
  "Santa Rita D'Oeste, Santa Rita D'Oeste (K2C)",
  "Miracatu, Miracatu - Santa Rita do Ribeira (K2D)",
  "Santa Rita do Passa Quatro, Santa Rita do Passa Quatro (K2E)",
  "Santo André, Santo André (K2F)",
  "Santópolis do Aguapeí, Santópolis do Aguapeí (K2G)",
  "São Carlos, São Carlos (K2H)",
  "São Sebastião, São Sebastião - Boiçucanga (K2I)",
  "São Sebastião, São Sebastião - Maresias (K2J)",
  "São Vicente, São Vicente (K2K)",
  "Sertãozinho, Sertãozinho (K2L)",
  "Santa Bárbara D'Oeste, Santa Bárbara D'Oeste (K2M)",
  "Atibaia, Atibaia - Tanque (K2N)",
  "Paraguaçu Paulista, Paraguaçu Paulista - Tabary (K2O)",
  "Suzano, Suzano - Terra Preta (K2P)",
  "Vargem Grande Paulista, Vargem Grande Paulista (K2Q)",
  "Guarujá, Guarujá - Vicente de Carvalho (K2R)",
  "Ribeirao Preto, Ribeirao Preto - Monte Paranapeanema (K2S)",
  "Rio Quente, Embu das Artes (K2T)",
  "Aparecida, Luiz Antonio (K2U)",
  "Poços de Caldas, Poços de Caldas - Marco Divisório SP (K2V)",
  "Acaiaca, Acaiaca (K2W)",
  "Água Boa, Água Boa (K2X)",
  "Santa Rita do Itueto, Santa Rita do Itueto - Água Limpa (K2Y)",
  "Além Paraíba, Além Paraíba - Mega Grill (K2Z)",
  "Alto Jequitibá, Alto Jequitibá (K3A)",
  "Carangola, Carangola - Alvorada (K3B)",
  "Ouro Preto, Ouro Preto - Amarantina (K3C)",
  "Cataguases, Cataguases - Areia Branca (K3D)",
  "Argirita, Argirita (K3E)",
  "Conceição de Ipanema, Coração de Jesus - Ataide (K3F)",
  "Natércia, Natércia - Atirado (K3G)",
  "Ressaquinha, Ressaquinha - Aurelio (K3H)",
  "Alpercata, Alpercata - Baguari (K3I)",
  "Cristina, Cristina - Barra Grande (K3J)",
  "Pedra Azul, Pedra Azul - Barreiro (K3K)",
  "Belmiro Braga, Belmiro Braga (K3L)",
  "Boa Esperança, Boa Esperança (K3M)",
  "São João do Paraíso, São João do Paraíso - Boa Sorte (K3N)",
  "Juiz De Fora, Juiz De Fora - Boa Ventura (K3O)",
  "Bom Sucesso, Bom Sucesso (K3P)",
  "Bonfim, Bonfim (K3Q)",
  "Madre de Deus de Minas, Madre de Deus de Minas (K3R)",
  "Brasópolis, Brasópolis (K3S)",
  "Pitangui, Pitangui - Brumado (K3T)",
  "Buritis, Buritis (K3U)",
  "Ouro Preto, Ouro Preto - Cachoeira do Campo (K3V)",
  "Cachoeira de Pajeú, Cachoeira de Pajeú (K3W)",
  "Galiléia, Galiléia - Cachoeirinha (K3X)",
  "Caeté, Caeté (K3Y)",
  "Campestre, Campestre (K3Z)",
  "Canápolis, Canápolis (K4A)",
  "Candeias, Candeias (K4B)",
  "Ribeirão das Neves, Ribeirão das Neves - Caneleiras (K4C)",
  "Cantagalo, Cantagalo - MG (K4D)",
  "Governador Valadares, Governador Valadares - Capim (K4E)",
  "Capinópolis, Capinópolis (K4F)",
  "Carmo da Mata, Carmo da Mata (K4G)",
  "Campos Gerais, Campos Gerais - Corrego de Ouro (K4H)",
  "Couto de Magalhães de Minas, Couto de Magalhães de Minas - Couto Magalhaes (K4I)",
  "Resplendor, Resplendor - Crenaque (K4J)",
  "Brasópolis, Brasópolis - Cruz Vera (K4K)",
  "Campos Gerais, Campos Gerais - Descaroçador (K4L)",
  "Manhuaçu, Manhuaçu - D Corrêa (K4M)",
  "Diamantina, Diamantina - Des Otoni (K4N)",
  "Uberlandia, Uberlandia - Douradinho (K4O)",
  "Carmo de Minas, Carmo de Minas - Entrada (K4P)",
  "Cássia, Cássia - Entrada (K4Q)",
  "Muzambinho, Muzambinho - Entrada (K4R)",
  "Betim, Betim - Entroncamento Entrada (K4S)",
  "Capitólio, Capitólio - Entroncamento Entrada (K4T)",
  "Careaçu, Careaçu - Entroncamento Entrada (K4U)",
  "Carmo da Cachoeira, Capim Branco - Entroncamento Entrada (K4V)",
  "Conceição do Rio Verde, Conceição do Rio Verde - Entroncamento Entrada (K4W)",
  "Coqueiral, Comercinho - Entroncamento Entrada (K4X)",
  "Córrego Fundo, Córrego Fundo - Entroncamento Entrada (K4Y)",
  "Divinópolis, Divinópolis - Entroncamento Entrada (K4Z)",
  "Elói Mendes, Elói Mendes - Entroncamento Entrada (K5A)",
  "Formiga, Formiga - Entroncamento Entrada (K5B)",
  "Heliodora, Heliodora - Entroncamento Entrada (K5C)",
  "Itaguara, Itaguara - Entroncamento Entrada (K5D)",
  "Itaúna, Itaúna - Entroncamento Entrada (K5E)",
  "Lavras, Lavras - Entroncamento Entrada (K5F)",
  "Mateus Leme, Mateus Leme - Entroncamento Entrada (K5G)",
  "Oliveira, Oliveira - Entroncamento Entrada (K5I)",
  "Paraguaçu, Paraguaçu - Entroncamento Entrada (K5J)",
  "Perdões, Perdoes - Entroncamento Entrada (K5K)",
  "Pimenta, Pimenta - Entroncamento Entrada (K5L)",
  "Santo Antônio do Amparo, Santo Antônio do Amparo - Entroncamento Entrada (K5M)",
  "São Gonçalo do Sapucaí, São Gonçalo do Sapucaí Entroncamento Entrada (K5N)",
  "Novo Oriente de Minas, Novo Oriente de Minas - Entroncamento Entrada (K5O)",
  "Três Corações, Três Corações - Entroncamento Entrada (K5P)",
  "Pedro Leopoldo, Pedro Leopoldo - Espraiado (K5Q)",
  "Fama, Fama - Gastapr Lopes (K5R)",
  "Ibirité, Ibirité - Geriva (K5S)",
  "Guarda-Mor, Guarda-Mor (K5T)",
  "Campina Verde, Campina Verde Honoropolis (K5U)",
  "Resplendor, Resplendor - Independência (K5V)",
  "Brumadinho, Brumadinho - Inhotim (K5W)",
  "Itabira, Itabira - Ipoema (K5X)",
  "Jaquirana, Jaquirana (K5Y)",
  "Juiz De Fora, Juiz De Fora - Centro (K5Z)",
  "Juiz De Fora, Juiz De Fora - Shopping Independencia (K6A)",
  "Lagoa Santa, Lagoa Santa (K6B)",
  "Lorena, Lorena - MG (K6C)",
  "Poços de Caldas, Poços de Caldas - Marco Divisório SP (K6D)",
  "Marilândia, Marilândia (K6E)",
  "Diamantina, Diamantina - Mendanha (K6F)",
  "Miradouro, Miradouro (K6G)",
  "Uberlandia, Uberlandia - Miraporanga (K6H)",
  "Campo Belo, Campo Belo - Mococa (K6I)",
  "Oliveira, Oliveira - Morro Ferro (K6J)",
  "Itueta, Itueta - Nova Itueta (K6K)",
  "Olhos D'Água, Olhos D'Água (K6L)",
  "Palma, Palma (K6M)",
  "Cabeceira Grande, Cabeceira Grande - Palmital (K6N)",
  "Paracatu, Paracatu (K6O)",
  "Pedralva, Pedralva - Estação Pedrão (K6P)",
  "Serro, Serro - Pedro Lessa (K6Q)",
  "Guaraciaba, Guaraciaba - Penha (K6R)",
  "Conselheiro Pena, Conselheiro Pena - Penha norte (K6S)",
  "Brumadinho, Brumadinho - Piedade do Paraopeba (K6T)",
  "Ouro Fino, Ouro Fino - Pinhalzinho Gois (K6U)",
  "Diamantina, Diamantina - Planalto de Minas (K6V)",
  "Planura, Planura (K6W)",
  "Caldas, Caldas - Caldas (K6X)",
  "São Gonçalo do Abaeté, São Gonçalo do Abaeté - Posto JK (K6Y)",
  "Manhuaçu, Manhuaçu - Realeza (K6Z)",
  "Reduto, Reduto (K7A)",
  "Monte Alegre de Minas, Monte Alegre de Minas - Rest Trevão (K7B)",
  "Paraopeba, Paraopeba - Retiro (K7C)",
  "Paracatu, Paracatu - Ribeiro (K7D)",
  "Tupaciguara, Tupaciguara - Rio das Pedras (K7E)",
  "São João da Mata, São João da Mata - Rio Dourado (K7F)",
  "Conselheiro Pena, Conselheiro Pena - Rio Eme (K7G)",
  "Ritápolis, Ritápolis - Entrada (K7H)",
  "Santa Luzia, Santa Luzia (K7I)",
  "Pouso Alto, Pouso Alto - Santana do Capivari (K7J)",
  "Lambari, Lambari - Santa Quiteria (K7K)",
  "Itamarandiba, Itamarandiba - São Domingos (K7L)",
  "Manhuaçu, Manhuaçu - São S do Sacramento (K7M)",
  "São Thomé das Letras, São Tomé das Letras (K7N)",
  "Governador Valadares, Governador Valadares - São Vitor (K7O)",
  "Sapucaí-Mirim, Sapucaí-Mirim (K7P)",
  "Diamantina, Diamantina - Senador Mourao (K7Q)",
  "Itabira, Itabira - Senhora do Carmo (K7R)",
  "Santana do Riacho, Santana do Riacho - Serra do Cipó (K7S)",
  "São Gotardo, São Gotardo - Serrinha (K7T)",
  "Jesuânia, Jesuânia - Sertãozinho (K7U)",
  "Manhuaçu, Manhuaçu - Sao Pedro do Avai (K7V)",
  "Mesquita, Mesquita - Travessão (K7W)",
  "Serro, Serro - Tres Barras (K7X)",
  "Uberaba, Uberaba - Graal Antares (K7Y)",
  "Viçosa, Viçosa (K7Z)",
  "Uberaba, Uberlandia - Xapetuba (K8A)",
  "Conselheiro Pena, Conselheiro Pena - Barra do Cuité (K8B)",
  "Apiúna, Apiúna - Subida (K8C)",
  "Araquari, Araquari - Itapocu (K8D)",
  "Balneário Piçarras, Balneário Piçarras (K8E)",
  "Biguaçu, Biguaçu - Tijuquinhas (K8F)",
  "Bom Jesus, Bom Jesus (K8G)",
  "Braço do Trombudo, Braço do Trombudo - Serril (K8H)",
  "Campo Alegre, Campo Alegre (K8I)",
  "Gaspar, Gaspar - Nereu Ramos (K8J)",
  "Governador Celso Ramos, Governador Celso Ramos - Armação (K8K)",
  "Guaramirim, Guaramirim - Poço Grande (K8L)",
  "Imbituba, Imbituba - Aracatuba (K8M)",
  "Ituporanga, Ituporanga - Rio Bonito (K8N)",
  "Joaçaba, Joaçaba - Capela (K8O)",
  "Nova Trento, Nova Trento - Lageadinho (K8P)",
  "Orleans, Orleans - Barracão (K8Q)",
  "São Carlos, São Carlos (K8R)",
  "São Francisco do Sul, São Francisco do Sul - Enseada (K8S)",
  "Três Barras, Três Barras - São Cristóvão (K8T)",
  "Urubici, Urubici - Águas Branca (K8U)",
  "Barra Bonita, Barra Bonita - SC (K8V)",
  "Chapeco, Chapeco - Posto Delta (K8W)",
  "Blumenau, Blumenau - Ponta Aguda (K8X)",
  "Praia Grande, Praia Grande - SC (K8Y)",
  "Lages, Lages - Índios (K8Z)",
  "Balneário Barra do Sul, Balneário Barra do Sul - Volta Grande (K9A)",
  "Blumenau, Blumenau - Vila Itoupava (K9B)",
  "Chapeco, Chapeco - São Nicolau (K9C)",
  "São João do Itaperiú, São João do Itaperiú (K9D)",
  "Chapeco, Chapeco - Alto da Serra (K9E)",
  "Bom Jesus, Bom Jesus (K9F)",
  "Camaquã, Camaquã (K9G)",
  "Campestre da Serra, Campestre da Serra - São Bernardo (K9H)",
  "Lajeado, Lajeado (K9I)",
  "Não-Me-Toque, Não-Me-Toque (K9J)",
  "Santa Rosa, Santa Rosa (K9K)",
  "Santa Vitória do Palmar, Santa Vitória do Palmar (K9L)",
  "Santo Augusto, Santo Augusto (K9M)",
  "São Francisco de Paula, São Francisco de Paula - Paradouro 3 (K9N)",
  "Torres, Torres - Vila São João (K9O)",
  "Tramandaí, Tramandaí - Jd Atlântico (K9P)",
  "Tramandaí, Tramandaí - Jd do Eden (K9Q)",
  "Tramandaí, Tramandaí - Nova Tramandai (K9R)",
  "Tramandaí, Tramandaí - Oasis Sul (K9S)",
  "Tramandaí, Tramandaí - Tramandaí do Sul (K9T)",
  "Alto Alegre, Alto Alegre (K9U)",
  "São Sebastião, Uruguaiana (K9V)",
  "Três Palmeiras, Três Palmeiras (K9W)",
  "Santa Cruz do Sul, Santa Cruz do Sul - T Portela (K9X)",
  "Santa Bárbara do Sul, Santa Bárbara do Sul (K9Y)",
  "Santa Maria, Santa Maria (K9Z)",
  "Novo Hamburgo, Nova Hamburgo - Posto 0300 (L1A)",
  "Porto Alegre, Porto Alegre - Haudi Park (L1B)",
  "Gravatai, Gravataí - Novo Mundo (L1C)",
  "Entre-Ijuís, Entre-Ijuís (L1D)",
  "Campo Novo, Campo novo (L1E)",
  "Campina das Missões, Campina das Missões (L1F)",
  "Alto Piquiri, Alto Piquiri (L1G)",
  "Alvorada do Sul, Alvorada do Sul - Itauna (L1H)",
  "Astorga, Astorga - Icara (L1I)",
  "Bandeirantes, Bandeirantes (L1J)",
  "Cafelândia, Cafelândia (L1K)",
  "Candói, Candói - Lagoa Seca (L1L)",
  "Candói, Candói - Paz (L1M)",
  "Cantagalo, Cantagalo (L1N)",
  "Capanema, Capanema (L1O)",
  "Carambeí, Carambeí - Tronco (L1P)",
  "Colorado, Colorado - Água das Pedras (L1Q)",
  "Colorado, Colorado - Alto Alegre (L1R)",
  "Contenda, Contenda (L1S)",
  "Faxinal, Faxinal - Três Barras (L1T)",
  "Francisco Beltrão, Francisco Beltrão - Itapejara do Oeste (L1U)",
  "Guaíra, Guaíra - PR (L1V)",
  "Ibaiti, Ibaiti - Campinho (L1W)",
  "Indiara, Indiara - Joaquim Murtinho (L1X)",
  "Irati, Irati - Basilio (L1Y)",
  "Mallet, Mallet - Dorizon (L1Z)",
  "Marmeleiro, Marmeleiro - São Domingos (L2A)",
  "Matelândia, Matelândia - Agro Cafeeira (L2B)",
  "Palmas, Palmas - Cruzo do Mangueirinha (L2C)",
  "Palmas, Palmas - PR (L2D)",
  "Palmeira, Palmeira - Colonia Witmarsun (L2E)",
  "Paranacity, Paranacity - Paranareal (L2F)",
  "Paranacity, Paranacity - Fioropolis (L2G)",
  "Prudentópolis, Prudentópolis - Relógio (L2H)",
  "Quitandinha, Quitandinha - Areia Branca (L2I)",
  "Rebouças, Rebouças - Riozinho (L2J)",
  "São Carlos, Registro (L2K)",
  "Santa Helena, Santa Helena - Ponte Queimada (L2L)",
  "Santo Antônio do Sudoeste, Santo Antônio do Sudoeste (L2M)",
  "Teixeira Soares, Teixeira Soares - Guarauna (L2N)",
  "Tibagi, Tibagi - Alto Amparo (L2O)",
  "Tibagi, Tibagi - Caetano Mendes (L2P)",
  "União da Vitória, União da Vitória - Godofredo (L2Q)",
  "Ventania, Ventania - Barro Preto (L2R)",
  "Espigão Alto do Iguaçu, Espigão Alto do Iguaçu - Alto da Serra (L2S)",
  "Apucarana, Apucarana (L2T)",
  "Arapongas, Arapongas (L2U)",
  "Atalaia, Atalaia (L2V)",
  "Nossa Senhora das Graças, Nossa Senhora das Graças - Bentopolis (L2W)",
  "Bom Sucesso de Itararé, Bom Sucesso (L2X)",
  "São José dos Pinhais, São José dos Pinhais - Campo Largo Roseira (L2Y)",
  "Ponta Grossa, Ponta Grossa - Guaragi (L2Z)",
  "Ponta Grossa, Ponta Grossa - Uvaia (L3A)",
  "Ponta Grossa, Ponta Grossa - Vila Velha (L3B)",
  "Guarapuava, Guarapuava - Guara (L3C)",
  "Londrina, Londrina - Conexão (L3D)",
  "Guarapuava, Guarapuava - Palmeirinha (L3E)",
  "Miraselva, Miraselva (L3F)",
  "Ponta Grossa, Ponta Grossa - Conexão (L3G)",
  "Piraquara, Piraquara - Residencia Fuck (L3H)",
  "Curitiba, Curitiba - Pinheirão (L3I)",
  "Curitiba, Curitiba - Diamante do Oeste (L3J)",
  "Curitiba, Curitiba Água Campina (L3K)",
  "Toledo, Toledo - Novo Sarandi (L3L)",
  "Santo Antônio do Caiuá, Santo Antonio do Caiuá - Sao João Caiuá (L3M)",
  "Santo Antônio do Caiuá, Santo Antonio do Caiuá (L3N)",
  "Cascavel, Cascavel - Sede Alvorada (L3O)",
  "Cascavel, Cascavel (L3P)",
  "Santa Inês, Santa Inês (L3Q)",
  "Quedas do Iguaçu, Quedas do Iguaçu - Salto Osório (L3R)",
  "Reserva do Iguaçu, Reserva do Iguaçu - Rondinha (L3S)",
  "Foz Do Iguaçu, Foz do Iguaçu - Três Pinheiros (L3T)",
  "Maripá, Maripá - Vila Nova (L3U)",
  "Brasilia, Brasilia - Ceilandia (L3V)",
  "Brasilia, Brasilia - Gama (L3W)",
  "Brasilia, Brasilia - Planaltina (L3X)",
  "Brasilia, Brasilia - Recanto das Emas (L3Y)",
  "Brasilia, Brasilia - Taguatinga (L3Z)",
  "Brasilia, Brasilia - Sobradinho (L4A)",
  "Alvorada, Alvorada (L4B)",
  "Araguaina, Araguaína (L4C)",
  "Brejinho de Nazaré, Brejinho de Nazaré (L4D)",
  "Marianópolis do Tocantins, Marianópolis do Tocantins (L4E)",
  "Palmas, Palmas (L4F)",
  "Ponte Alta do Bom Jesus, Ponte Alta do Bom Jesus (L4G)",
  "Porto Alegre do Tocantins, Porto Alegre do Tocantins (L4H)",
  "São Valério da Natividade, São Valério da Natividade (L4I)",
  "Rio Branco, Rio Branco (L4J)",
  "Santa Luzia D'Oeste, Santa Luzia D'Oeste (L4K)",
  "Alvorada D'Oeste, Alvorada D'Oeste (L4L)",
  "Costa Marques, Costa Marques (L4M)",
  "Machadinho D'Oeste, Machadinho D'Oeste (L4N)",
  "São Francisco do Guaporé, São Francisco do Guaporé - Alta Floresta (L4O)",
  "Boa Vista, Boa Vista (L4P)",
  "Bonfim, Bonfim - RR (L4Q)",
  "Iracema, Iracema (L4R)",
  "Rorainópolis, Rorainópolis - Nova Colina (L4S)",
  "São Luiz, São Luiz - São Luiz do Anaua (L4T)",
  "Boca do Acre, Boca do Acre (L4U)",
  "Belem, Belém (L4V)",
  "Barão do Melgaço, Santa Izabel do Pará (L4W)",
  "Breves, Breves - Bom Jesus - PA (L4X)",
  "Capanema, Capanema - PA (L4Y)",
  "Acailândia, Igarapé Grande (L4Z)",
  "Itaituba, Itaituba - Mirituba (L5A)",
  "Itaituba, Itaituba - Moraes de Almeida (L5B)",
  "Marapanim, Marapanim - Maruda (L5X)",
  "Novo Progresso, Novo Progresso - Alvorada da Amazonia (L5D)",
  "Ponta de Pedras, Ponta de Pedras (L5E)",
  "Trairão, Trairão - Bela vista do Caracol (L5F)",
  "Piranguinho, Piranguinho - Olegário Maciel Entrada (K5H)"
];